module.exports = __webpack_public_path__ + "static/venkateshwar-rao-b288212378a3431c07705d62a114a093.jpg";